import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';

export interface SidebarHeaderNextUniDriver extends BaseUniDriver {
  getTitle: () => Promise<string>;
  getSubtitle: () => Promise<string>;
  getSkin: () => Promise<string>;
}
